export default function getSearchResultsSelector(state: Store): any[] {
    return state.search.results;
}
